import routing from 'Utilities/routing';

export const PAAS_ROUTE_STEPS = {
  ADDITIONAL_PHOTOS: '/additional-photos',
  FEATURES: '/features',
  FINANCE: '/finance',
  ISSUES: '/issues',
  ISSUES_DETAILS: '/issues/details',
  KEYS: '/keys',
  NO_PROOF_OF_PURCHASE: '/proof-of-purchase/no-proof-of-purchase',
  PERSONAL_DETAILS: '/details',
  PHOTOS: '/photos',
  PROOF_OF_PURCHASE: '/proof-of-purchase',
  UPLOAD_PHOTOS: '/upload-photos',
};

export const PAAS_PARENT_FOLDER_ROUTE = '/profiling';
export const PAAS_ROUTE_ROOT = `${routing.vrmPath}${PAAS_PARENT_FOLDER_ROUTE}`;
export const PAAS_ROUTE = `${PAAS_ROUTE_ROOT}/:step?/:substep?`;

export const PAAS_PHOTOS_URL = `${PAAS_ROUTE_ROOT}${PAAS_ROUTE_STEPS.PHOTOS}`;

export const PAAS_SENTRY_TAGS = 'profiling service';
